import { Channel } from '@/types/channel.types';
import { BrandliveEvent } from '@/types/projects.types';
import { LanguagesAbbr } from '@/types/translation.types';
import getPrefixUrl from '@/utils/get-prefix-url';
import { stageEnvironment } from '@/utils/urls';

export const getUrl = (
  channel: Channel,
  workingProject: BrandliveEvent,
  publishedUrl: string,
  language: LanguagesAbbr,
  sessionUUID?: string
) => {
  const isDev = stageEnvironment.isDev;
  const basePath = isDev ? 'http://localhost:3000' : getPrefixUrl(channel.url);
  const eventPath = isDev ? `event/${workingProject.uuid}` : publishedUrl;

  if (sessionUUID) {
    return `${basePath}/${eventPath}/${language}/session/${sessionUUID}`;
  }
  return `${basePath}/${eventPath}/${language}`;
};
